import { useContext } from 'react';
import styles from './About.module.css'
import { PhoneShakeFilled } from '@fluentui/react-icons';
import { AppStateContext } from '../../state/AppProvider';
import { UIEnv } from '../../api';

const responsibleAiGuidelinesUrl = 'https://csprod-imfx.opentext.cloud/otcs/cs.exe/app/nodes/15707739'
const privacyNoticeUrl = 'https://www.imf.org/en/About/privacy-notice'
const aiAtTheFundUrl = 'https://intlmonetaryfund.sharepoint.com/sites/KeyIssues/SitePages/AI-at-the-Fund.aspx'
const serviceHubUrl = 'https://imf.service-now.com/servicehub'

const About = () => {
  const appStateContext = useContext(AppStateContext)
  const ui = appStateContext?.state?.frontendSettings?.ui

  return (
    <div className={styles.container}>
      <h1>About <span className={styles.botName}>SAMMY</span></h1>

      <p>
        Welcome to the future of convenience! <span className={styles.botName}>SAMMY</span> is your AI-driven concierge, specially designed to enhance your experience during the Spring and Annual Meetings. Whether you have questions about logistics, registration, schedule of events, information about the speakers, SAMMY is here to help!
      </p>

      <h2>Key Features:</h2>
      <ul>
        <li>Instant Responses: Get real-time responses to your inquiries, right when you need them!</li>
        <li>Easy Navigation: Navigate the conference with confidence, as SAMMY can guide you through the logistics of the meetings with ease.</li>
        <li>Always Available: Whether you’re an early bird or a night owl, SAMMY is always just a message away, ready to assist you 24/7.</li>
      </ul>

      <h2>Privacy Notice</h2>
      <p>
        The chatbot is designed to provide general information and assist with basic queries on IMF’s Spring and Annual meetings only. While we strive to provide accurate and up-to-date information, the chatbot may not always provide complete or error-free responses. We do not guarantee the accuracy, or completeness of any information or advice provided through the chatbot. The chatbot's responses are based on the information available at the time of interaction and may change over time. By using this chatbot, you acknowledge and agree that your interactions, including prompts and responses may be recorded and reviewed, to improve the accuracy, reliability, and quality of the Bot’s responses.
      </p>
      <p>
        Your data will be handled in accordance with the <a href={privacyNoticeUrl} target="_blank" rel="noopener noreferrer">privacy policy</a> of the IMF. If you have any concerns about data usage, please refrain from sharing any sensitive or personal information through this chatbot.
      </p>
    </div>
  )
}

export default About
